import { parseISO, addMinutes, addDays } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export const getTimes = (start: any, interval: number): string[] => {
  const rangeTime: string[] = []
  const startDate = parseISO(start)
  const dateStr = formatInTimeZone(startDate, 'UTC', 'yyyy-MM-dd')
  const finalTime = addDays(parseISO(`${dateStr}T00:00:00Z`), 1)

  let initialTime = addMinutes(startDate, interval)

  while (initialTime <= finalTime) {
    rangeTime.push(formatInTimeZone(initialTime, 'UTC', 'HH:mm'))
    initialTime = addMinutes(initialTime, interval)
  }

  return rangeTime
}

interface CountryNames {
  [key: string]: string
}
export const countryNames: CountryNames = {
  BR: 'Brasil',
  IE: 'Irlanda',
  US: 'Estados Unidos',
  UK: 'Reino Unido',
  FR: 'França',
  DE: 'Alemanha',
  IT: 'Itália',
  ES: 'Espanha',
  JP: 'Japão',
  CN: 'China',
  RU: 'Rússia',
  CA: 'Canadá',
  AU: 'Austrália',
  IN: 'Índia',
  MX: 'México',
  KR: 'Coreia do Sul',
  SA: 'Arábia Saudita',
  AR: 'Argentina',
  ID: 'Indonésia',
  ZA: 'África do Sul',
  NG: 'Nigéria',
  EG: 'Egito',
  TH: 'Tailândia',
  NL: 'Países Baixos',
  BE: 'Bélgica',
  CH: 'Suíça',
  PT: 'Portugal',
  AT: 'Áustria',
  SE: 'Suécia',
  TR: 'Turquia',
  PL: 'Polônia',
  BO: 'Bolívia',
  CL: 'Chile',
  CO: 'Colômbia',
  EC: 'Equador',
  GY: 'Guiana',
  PY: 'Paraguai',
  PE: 'Peru',
  SR: 'Suriname',
  UY: 'Uruguai',
  VE: 'Venezuela',
}
